import styled from "styled-components"

export const OurStoryWrapper = styled.section`
    background: linear-gradient(180.34deg, #144056 1.48%, #428AC9 140.7%);
`
